import { Locale } from 'constants/locale';
import { intlMessagesEn } from 'locale/en';
import { intlMessagesId } from 'locale/id';

export const intlMessages = {
  [Locale.EN]: intlMessagesEn,
  [Locale.ID]: intlMessagesId
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/locale/tool/mapper.ts